export const SET_SERVER_PROPS = 'SET_SERVER_PROPS';
export const RESET_LOCAL_STATE = 'RESET_LOCAL_STATE';
export const RESTORE_LOCAL_STATE = 'RESTORE_LOCAL_STATE';
export const ADD_USER_DATA = 'ADD_USER_DATA';
export const ADD_WALLETS_INFO = 'ADD_BFT_WALLET';
export const ADD_MARKET_SETTINGS = 'ADD_MARKET_SETTINGS';
export const SET_SECONDARY_MARKET_DATA = 'SET_SECONDARY_MARKET_DATA';
export const SET_ASSET_DETAILS = 'SET_ASSET_DETAILS';
export const UPDATE_ON_CANCEL_ORDER = 'UPDATE_ON_CANCEL_ORDER';
export const SET_ASSETS_ASSET_DETAILS = 'SET_ASSETS_ASSET_DETAILS';
